@use 'src/core/styles/mediaQueries';
@use 'src/core/styles/variables';

/* stylelint-disable no-descending-specificity */
// Hide arrows from numeric inputs
.input::-webkit-outer-spin-button,
.input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.input[type='number'] {
  -moz-appearance: textfield;
}

.labelWrapper {
  display: flex;
  align-items: center;
  font-weight: normal;
}

.label {
  margin-bottom: 8px;
  color: var(--dark-blue-500);
}

.labelTooltip {
  display: inline-block;
  margin-left: 8px;

  svg {
    position: relative;
    top: -1px;
  }
}

.optional {
  display: inline-block;
  margin-left: 10px;
  color: var(--dark-blue-300);
}

.inputWrapper {
  --input-border-radius: #{variables.$four-px-in-em};
  --input-border-width: #{variables.$one-px-in-em};
  --input-color-error: var(--admin-error);
  --input-border-color: #ced2d9;
  --input-focus-color: #4d9aff;
  --input-placeholder-color: var(--grey-400);
  display: inline-flex;
  align-items: center;
  width: 100%;
  height: 3em;
  padding: 12px 16px 14px;
  transition: border-color 100ms linear;
  border: var(--input-border-width) solid var(--input-border-color);
  border-radius: var(--input-border-radius);
  background: var(--white-100);
  font-size: var(--font-size-body);
  font-weight: normal;

  &:focus-within {
    border: var(--input-border-width) solid var(--input-focus-color);
    border-radius: var(--input-border-radius);
  }

  &.hasError {
    border: var(--input-border-width) solid var(--input-color-error);
  }
}

.prefix {
  margin-right: 2px;
  color: var(--input-placeholder-color);
}

.input {
  width: 100%;
  /* Correct input flex Firefox bug https://bugzilla.mozilla.org/show_bug.cgi?id=1242914 */
  min-width: 0;
  padding: 0;
  border: 0;
  border-radius: var(--input-border-radius);
  box-shadow: none;
  color: var(--dark-blue-500);
}

.suffix {
  flex-shrink: 0;
  margin-left: 8px;
  color: var(--input-placeholder-color);

  ~ .fieldTooltip {
    margin-left: 4px;
  }
}

.fieldTooltip {
  display: block;
  margin-left: 8px;
  color: var(--input-placeholder-color);

  .fieldTooltipIcon {
    margin-bottom: 1px;
    vertical-align: middle;
  }
}

.helperText {
  margin-top: 4px;
  color: var(--dark-blue-300);
  font-size: var(--font-size-nav);
  font-weight: normal;
}

.error {
  display: flex;
  width: 100%;
  margin-top: 4px;
  color: var(--admin-error);
  font-size: var(--font-size-nav);
  font-weight: normal;

  .errorIcon {
    flex-shrink: 0;
    margin: 4px 4px 0 0;
  }
}
